import getStore from '../data/store/store';
import getPersonalSchedulingPage from '../services/getPersonalSchedulingPage';
import initializeSettings from '../data/actions/initializeSettings';
import { trace } from 'owa-trace';

/**
 * Gets personal booking page settings and initialize store if not present.
 */
export default async function initPbpSettings(): Promise<boolean> {
    let { publishingSettings } = getStore();
    if (!publishingSettings) {
        try {
            let pbpSettings = await getPersonalSchedulingPage();
            if (!pbpSettings) {
                return false;
            }

            initializeSettings(pbpSettings);
        } catch (e) {
            trace.warn(e.message || 'initPbpSettings failed');
            return false;
        }
    }

    return true;
}
